import { render, staticRenderFns } from "./Tempo.vue?vue&type=template&id=475eeef5&scoped=true&"
import script from "./Tempo.vue?vue&type=script&lang=js&"
export * from "./Tempo.vue?vue&type=script&lang=js&"
import style0 from "./Tempo.vue?vue&type=style&index=0&id=475eeef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475eeef5",
  null
  
)

export default component.exports